import { PARTNER_KEYS, resolvePartnerSync } from "../../utils/partner";
import { v2Tokens } from "./tokens";
import openSansBold from "../../fonts/open-sans/OpenSans-Bold.ttf?url";
import openSansExtraBold from "../../fonts/open-sans/OpenSans-ExtraBold.ttf?url";
import openSansRegular from "../../fonts/open-sans/OpenSans-Regular.ttf?url";

// The weights the welcome screen renders: 400 body, 700 CTA + carousel labels,
// 800 title. Preloading these is what keeps the first paint from reflowing when
// the brand font lands (font-display: swap, no font gate).
const OPEN_SANS_URLS = [openSansRegular, openSansBold, openSansExtraBold];

/**
 * Starts the webfont download as early as the bundle can, before React renders.
 *
 * Without this the fetch cannot begin until ThemeProvider has named the family in
 * --v2-font-family, because an @font-face file is only requested once a rendered
 * element matches it. That put the whole download *after* the first paint.
 *
 * Injected from JS rather than declared in index.html because Vite hashes the font
 * filenames, so the URL isn't known until build time. `crossorigin` is required even
 * for same-origin font preloads — without it the browser discards the preload and
 * fetches the file a second time.
 */
export default function preloadFonts() {
  // The partner isn't in the store yet (setPartner happens inside silentLogin), so
  // read it off the URL the same way the "/" dispatcher does.
  const partner = resolvePartnerSync(PARTNER_KEYS.NONE);
  const fontFamily = (v2Tokens[partner] || {})["--v2-font-family"] ?? "";

  // Only the OpenSans partners: preloading a font the page never renders wastes the
  // bandwidth and logs an unused-preload warning.
  if (!fontFamily.includes("OpenSans")) return;

  OPEN_SANS_URLS.forEach((href) => {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "font";
    link.type = "font/ttf";
    link.crossOrigin = "anonymous";
    link.href = href;
    document.head.appendChild(link);
  });
}
